export type ChatDirection = "in" | "out";

export type ChatMessageStatus =
  | "queued"
  | "sent"
  | "delivered"
  | "read"
  | "failed"
  | "received";

export interface ChatMessage {
  direction: ChatDirection;
  body: string;
  message_type: string;
  status: ChatMessageStatus;
  at: string | null;
  provider_message_id: string | null;
  event_id: string | null;
}

export interface Chat {
  id: string;
  client_id: string;
  instance_name: string;
  /**
   * WHATSAPP-BAILEYS or WHATSAPP-BUSINESS. Only the Meta integration is bound
   * by the 24-hour reply window, so a QR instance keeps its composer open.
   * Present on single-chat reads only.
   */
  integration: string | null;
  contact_phone: string;
  phone_key: string;
  contact_name: string | null;
  last_message_at: string | null;
  last_direction: ChatDirection | null;
  unread_count: number;
  /**
   * When WhatsApp's reply window closes. Past this a Meta Cloud API instance
   * accepts only approved templates, so free text must be blocked rather than
   * sent into a silent rejection.
   */
  window_expires_at: string | null;
  messages: ChatMessage[];
}

export interface SendMessageResult {
  event_id: string;
  chat_id: string;
  body: string;
  status: ChatMessageStatus;
  at: string;
}

export function replyWindowOpen(chat: Chat | null | undefined): boolean {
  if (!chat?.window_expires_at) return false;
  return new Date(chat.window_expires_at).getTime() > Date.now();
}

/**
 * Whether a free-text reply would be refused by WhatsApp.
 *
 * Only true for a Meta Cloud API instance whose 24-hour window has closed. A
 * Baileys (QR) instance has no such rule, and blocking one would take away a
 * send that would have worked. Unknown integration is treated as allowed --
 * a message the provider rejects is visible; a composer disabled for no reason
 * is not.
 */
export function freeTextBlocked(chat: Chat | null | undefined): boolean {
  if (!chat || chat.integration !== "WHATSAPP-BUSINESS") return false;
  return !replyWindowOpen(chat);
}
